export const ACCESS_TOKEN_COOKIE = "access_token";
export const REFRESH_TOKEN_COOKIE = "refresh_token";

// The Monaco session keypair (ed25519) is the long-lived credential under the
// session-key auth scheme. The private key must stay client-side, so it is
// persisted in localStorage rather than a cookie (cookies are sent to the
// backend on every request).
export const MONACO_SESSION_STORAGE_KEY = "monaco_session";

export const QUOTE_TOKEN_ADDRESSES = [
  "So11111111111111111111111111111111111111112",
  "EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v",
  "Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB",
  "USD1ttGY1N17NEEHLmELoaybftRBUSErhqYiQzvEmuB",
];

export const WRAPPED_TOKEN_ADDRESS =
  "So11111111111111111111111111111111111111112";

export const USDC_TOKEN_ADDRESS =
  "EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v";
export const USD1_TOKEN_ADDRESS = "USD1ttGY1N17NEEHLmELoaybftRBUSErhqYiQzvEmuB";

export const DEFAULT_TRACKED_GROUP_EMOJI = "💰";
export const DEFAULT_TRACKED_WALLET_EMOJI = "🔥";
export const DEFAULT_TRACKED_SMART_NOTIFICATION_EMOJI = "🔥";

export const LOW_LIQUIDITY_THRESHOLD = 2000;

export const PROTOCOL_COLORS = {
  HYPERLIQUID: "#97fce5",
  MONACO: "#FFFFFF",
} as const;
